import { ActionTree } from 'vuex'
import { AddressState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<AddressState, RootState> = {
}
